import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { LoginComponent } from './login/login.component';
import { RouterModule, Routes } from '@angular/router';
import { SelezioneDinamicaDirective } from './direttive/selezione-dinamica.directive';
import { OmbrelloniModule } from './ombrelloni.module';
import { SharedModule } from './shared.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SpinnerInterceptor } from './interceptors/spinner.interceptor';

/* ######################################################  */

const routes: Routes = [
  // Regular Route

  { path: 'anagrafica-clienti', loadChildren: () => import('./anagrafica-clienti/anagraficaClienti.module').then(m => m.AnagraficaClientiModule) },
  { path: 'anagrafica-rivenditori', loadChildren: () => import('./anagrafica-rivenditori/anagraficaRivenditori.module').then(m => m.AnagraficaRivenditoriModule) },
  { path: 'gest-magazzino', loadChildren: () => import('./gest-magazzino/gestioneMagazzino.module').then(m => m.GestioneMagazzinoModule) },
  { path: 'gest-lista-piatti', loadChildren: () => import('./gest-listapiatti/gestioneListapiatti.module').then(m => m.GestioneListapiattiModule) },
  { path: 'gest-ristorante', loadChildren: () => import('./gest-ristorante/gestioneRistorante.module').then(m => m.GestioneRistoranteModule) },
  { path: 'gest-ordini-bar', loadChildren: () => import('./gest-ordini-bar/gestioneOrdiniBar.module').then(m => m.GestioneOrdiniBarModule) },
  { path: 'storico-ordini', loadChildren: () => import('./storico-ordini/storicoOrdini.module').then(m => m.StoricoOrdiniModule) },
  { path: 'storico-ordini-completo', loadChildren: () => import('./storico-ordini-completo/storicoOrdiniCompleto.module').then(m => m.StoricoOrdiniCompletoModule) },
  { path: 'riepilogo-incassi', loadChildren: () => import('./riepilogo-incassi/riepilogo-incassi.module').then(m => m.RiepilogoIncassiModule) },
  { path: 'news-page', loadChildren: () => import('./news-page/news.module').then(m => m.NewsModule) },
  { path: 'profilo', loadChildren: () => import('./profilo/profilo.module').then(m => m.ProfiloModule) },
  { path: 'rivenditori', loadChildren: () => import('./rivenditori/rivenditori.module').then(m => m.RivenditoriModule) },
  { path: 'app-login', component: LoginComponent }


];

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    LoginComponent,
    SelezioneDinamicaDirective,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    OmbrelloniModule,
    NgxSpinnerModule,

    RouterModule.forRoot(
      routes,
      { enableTracing: false } // <-- debugging purposes only
    )
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SpinnerInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
